import { render, staticRenderFns } from "./AdminWorkplaceFormulas.vue?vue&type=template&id=a615b9f6&"
import script from "./AdminWorkplaceFormulas.vue?vue&type=script&lang=js&"
export * from "./AdminWorkplaceFormulas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports